import React from 'react';
import PropTypes from 'prop-types';
import { FormGroup, FormControl, ControlLabel, Button, Image, Col, Alert} from 'react-bootstrap';

import mmkLogo from '../../assets/images/logo.png';
import showIcon from '../../assets/images/password-show.svg';
import hideIcon from '../../assets/images/password-hide.svg';
import errorIcon from '../../assets/images/error-exclamation-point.svg';
import loginStyle from './loginForm.css';
import Commonfooter from '../UI/FooterCommon/Commonfooter'
import ConsoleLog from '../../hoc/ConsoleLog/ConsoleLog';
/**
* @desc  Shows Form to Login with user-email and password 
* @version 1.0.1
* @author  Lakshmikanth
*/
class LoginForm extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      username: (props.defaultUsername) ? props.defaultUsername : '',
      isFirstTimeLogin: (props.defaultUsername) ? true : false,
      password: '',
      passwordView: false,
      error: '',
      errorPosition:'',
    };
  }

/**
 * @desc Login with the user-email and password filled
 * @param event
 * @return null
 */
onSubmit = (event) => {
  event.preventDefault();
  if(this.state.username.trim==''||this.state.password.trim==''){
    let errorPosition = [];      
    if(this.state.username.trim() ==''){        
      errorPosition = errorPosition.concat('username');
    }
    if (this.state.password.trim() ==''){
      errorPosition = errorPosition.concat('password');
    }
    this.setState({
      errorPosition: errorPosition,error:''
    });
  }
  else{
    this.props.onSubmit(this.state.username.trim().toLowerCase(), this.state.password, 'recruiter')
    .catch((err) => {
      ConsoleLog('err.code',err);
    if (err.code === 'UserNotFoundException') 
      {
        this.setState({ error:'Invalid User Name' ,errorPosition:'username'});
      } 
    else if (err.code === "InvalidParameterException") 
      {
        this.setState({ error:'Invalid User Name',errorPosition:'username' });
      } 
      else if (err.code === "NotAuthorizedException") 
      {
        this.setState({ error:'Password incorrect, please try with valid password',errorPosition:'password' });
      } 
      else if(err.message  === 'Password attempts exceeded'){
        this.setState({ error:'Password attempts exceeded, please try with valid password',errorPosition:'password' });
      }
    else 
      {
        this.setState({ error: err.message })
      }
    });
  }
}
/**
 * @desc Fill the user-email field
 * @param event
 * @return null
 */
  changeUsername = (event) => {
    this.setState({ username: event.target.value, error:'', errorPosition:'' });
  }
/**
 * @desc Fill the user-password field
 * @param event
 * @return null
 */
  changePassword = (event) => {
    this.setState({ password: event.target.value, error:'', errorPosition:'' });
  }
/**
 * @desc Show/Hide password
 * @param event
 * @return null
 */
  passwordView=()=>{
    this.setState({ passwordView:!this.state.passwordView });
  }

  componentWillUnmount = () => {
    this.props.clearCache();
  }

  componentDidUpdate(nextProps) {
    if(this.props.errorMessage && this.props !== nextProps) {
      this.setState({ error: this.props.errorMessage });
    }
  }

  render() {
    const { username, errorPosition, error, password, passwordView, isFirstTimeLogin } = this.state
    const urlArray = window.location.href.split('/');
    const redirectUrl = (urlArray[3] === "recruiter") ? "/recruiter/forgot-password" : "/forgot-password";
    return (
      <React.Fragment>
        <div className="login-section">  
          <div className="login-wrapper paddingtop-80">
            <div className="login-container">
              <div className="form-wrapper">
                <form onSubmit={this.onSubmit}>
                  <div className="text-center"> 
                    <div className="login-title">Access your Talent Application</div>
                  </div>
                  <FormGroup>  
                    <ControlLabel>Email</ControlLabel>
                    <p className="login-error-p error-message ">
                        {(this.state.username.trim() =='' && this.state.errorPosition.includes("username")) ?
                        <p><img src={errorIcon} title="Error" />Please enter your email</p>:(this.state.error && this.state.errorPosition == "username") ?<p><img src={errorIcon} title="Error" />{this.state.error}</p>:""}
                    </p>
                    <FormControl
                      id="formEventNameText"
                      help="Use your email address provided to you by the admin."
                      placeholder="Please enter your email"
                      onChange={this.changeUsername}
                      value={username}
                      autoFocus
                      className={(errorPosition.includes("username")) ? "invalid-error" : "text-field"}
                      margin="normal"
                    />
                  </FormGroup>
                  <FormGroup className="form-group-password">                
                    <ControlLabel>
                      { (isFirstTimeLogin) ? "Temporary password" : "Password" }
                    </ControlLabel>
                    <p className="login-error-p error-message">
                        {(this.state.password.trim() =='' && this.state.errorPosition.includes("password")) ?
                        <p><img src={errorIcon} title="Error" />Please enter password</p>:(this.state.error && this.state.errorPosition == "password") ?<p><img src={errorIcon} title="Error" />{this.state.error}</p>:""}
                    </p>
                      <FormControl
                        id="formEventPasswordText"
                        type={(passwordView) ? "text" : "password"}
                        placeholder="Please enter your password"
                        onChange={this.changePassword}
                        // autoFocus
                        className={(errorPosition.includes("password")) ? "invalid-error" : "text-field"}
                      />
                      <span className="login-control" onClick={() => this.passwordView() }>{passwordView ? <img src={hideIcon} title="Hide password" /> : <img src={showIcon} title="Show password"/>}</span>
                  </FormGroup>

                  {/* { (error) ? 
                    <p className="error-message"><img src={errorIcon} title="Error" />{error}</p>
                  : null } */}

                  <Button type="submit" className="btn btn-lg" variant="raised" color="default">
                    Login
                  </Button>
                  { (!isFirstTimeLogin) ? <p className="f-password"><a href={redirectUrl} tabIndex="4" >Forgot password?</a></p> : null }
                </form>
              </div>
            </div>
         
          </div>         
        </div>        
        <div className="p-policy">
          <Commonfooter />
        </div>
      </React.Fragment>   
    )
  }
}

LoginForm.propTypes = {
  onSubmit: PropTypes.func,
  clearCache: PropTypes.func,
  username: PropTypes.string,
  defaultUsername: PropTypes.string,
  error: PropTypes.string,
};

export default LoginForm;


// WEBPACK FOOTER //
// ./src/components/Authentication/LoginForm.js